import { View, Text, StyleSheet } from "@react-pdf/renderer";
import React from "react";
import generalStyle from "../../styles";

export const FooterBlock = ({ generatedDate, themeData }) => {
  const footerBlocks = StyleSheet.create({
    footerWrapper: {
      backgroundColor: themeData.secondary,
      position: "absolute",
      bottom: 0,
      color: "white",
      width: "100%",
      padding: "13 27 13",
      fontSize: 12,
    },
    footerRow: {
      ...generalStyle.inLineBlocks,
      marginLeft: "auto",
    },
    dateReport: {
      ...generalStyle.inLineBlocks,
      marginRight: 15,
    },
  });

  return (
    <View
      data-testid="footer-block"
      style={footerBlocks.footerWrapper}
      fixed
      render={() => (
        <View style={footerBlocks.footerRow} data-testid="footer-row">
          <View style={footerBlocks.dateReport}>
            <Text style={generalStyle.semiBold}>Date of Report:</Text>
            <Text>{generatedDate}</Text>
          </View>

          <Text
            style={generalStyle.bold}
            render={({ pageNumber, totalPages }) =>
              `${pageNumber}/${totalPages}`
            }
          />
        </View>
      )}
    />
  );
};
